import getCanShowLoyaltyEsimBenefitSelector from 'loyalty/selectors/getCanShowLoyaltyEsimBenefitSelector'
import getIsCheckoutEsimInternationalTrip from './getIsCheckoutEsimInternationalTrip'

const getCanShowCheckoutLoyaltyEsimBenefit = getCanShowLoyaltyEsimBenefitSelector(
  (state: App.State) => getIsCheckoutEsimInternationalTrip(state),
)

export default getCanShowCheckoutLoyaltyEsimBenefit
